import Vue from 'vue'
// eslint-disable-next-line import/no-named-as-default
import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad)
